import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import {
  setContactInfo,
  schedulePriceQuote,
  scheduleBook,
  setSelectedPaymentMethodId,
  setSelectedRewardsAccountReferenceId,
  setPriceQuote,
  fetchApplicableTravelWalletItems,
} from "../../../actions/actions";
import { IStoreState } from "../../../../../reducers/types";
import { DesktopCarBookWorkflow } from "./component";
import { getCarShopSelectedVehicle } from "../../../../shop/reducer";
import {
  getSelectedDriverAge,
  getIsBookingValid,
  getConfirmationDetails,
  isTravelerStepComplete,
  isContactStepComplete,
  getPriceDifferenceAcknowledged,
  areAllStepsCompletedInCheckout,
  getConfirmationEmail,
  getConfirmationPhoneNumber,
  getPriceQuote,
  getCombinedBookingSteps,
  getPriceQuoteErrors,
  getIsHertzProvider,
  getHertzLoyaltyRewardsNumber,
  getConfirmationDetailsError,
  getIsTravelWalletPaymentOnly,
  getUseV1PurchaseFlow,
  getOfferToApply,
  getInsuranceBaseTrackingProperties,
  getFlightInfoFieldSpec,
  getIsFlightInfoValid,
} from "../../../reducer";
import { fetchTravelWalletCreditHistory } from "../../../../travel-wallet/actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  driverAge: getSelectedDriverAge(state),
  selectedVehicle: getCarShopSelectedVehicle(state),
  combinedBookingSteps: getCombinedBookingSteps(state),
  isBookingValid: getIsBookingValid(state),
  isTravelerStepComplete: isTravelerStepComplete(state),
  isContactStepComplete: isContactStepComplete(state),
  confirmation: getConfirmationDetails(state),
  priceDifferenceAcknowledged: getPriceDifferenceAcknowledged(state),
  allStepsCompleted: areAllStepsCompletedInCheckout(state),
  email: getConfirmationEmail(state),
  phoneNumber: getConfirmationPhoneNumber(state),
  priceQuote: getPriceQuote(state),
  priceQuoteErrors: getPriceQuoteErrors(state),
  isHertzProvider: getIsHertzProvider(state),
  hertzLoyaltyRewardsNumber: getHertzLoyaltyRewardsNumber(state),
  confirmationDetailsErrors: getConfirmationDetailsError(state),
  isTravelWalletPaymentOnly: getIsTravelWalletPaymentOnly(state),
  useV1PurchaseFlow: getUseV1PurchaseFlow(state),
  offerToApply: getOfferToApply(state),
  insuranceBaseTrackingProperties: getInsuranceBaseTrackingProperties(state),
  hasFlightInfoField: getFlightInfoFieldSpec(state) != null,
  isFlightInfoValid: getIsFlightInfoValid(state),
});

const mapDispatchToProps = {
  setContactInfo,
  schedulePriceQuote,
  scheduleBook,
  setSelectedPaymentMethodId,
  setSelectedRewardsAccountReferenceId,
  setPriceQuote,
  fetchApplicableTravelWalletItems,
  fetchTravelWalletCreditHistory,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type DesktopCarBookWorkflowConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedDesktopCarBookWorkflow = withRouter(
  connector(DesktopCarBookWorkflow),
);
